const prependString = (str, symbol = '0', count = 2) => {
  return `${new Array(count).fill(symbol).join('')}${str}`.slice(-count);
};

export default prependString;
